<div mat-dialog-title>Add Fund</div>
<div mat-dialog-content>
  <form [formGroup]="formGroup">
    <div class="row gutters">
      <mat-form-field class="col-md-6">
        <mat-label>Fund Name</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>
      <mat-form-field class="col-md-6">
        <mat-label>Legal Name</mat-label>
        <input matInput formControlName="legal_name">
        @if (formGroup.controls.legal_name.hasError('required')) {
          <mat-error>Fund name must not be empty</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="row gutters">
      <mat-form-field class="col-md-6">
        <mat-label>Fund Type</mat-label>
        <mat-select formControlName="fund_type_id">
          <mat-option disabled>&mdash;</mat-option>
          @for (fundType of addFundService.fundTypes$ | async; track fundType) {
            <mat-option [value]="fundType.id">{{fundType.name}}</mat-option>
          }
        </mat-select>
        @if (formGroup.controls.fund_type_id.hasError('required')) {
          <mat-error>Fund Type must be selected</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="col-md-6">
        <mat-label>Managing Member</mat-label>
        <input matInput formControlName="managing_member_name">
      </mat-form-field>
    </div>
    <div class="row gutters">
      <mat-form-field class="col-md-6">
        <mat-label>Closing Date</mat-label>
        <input [matDatepicker]="closingDate" formControlName="close_date" matInput>
        <mat-datepicker-toggle matSuffix [for]="closingDate"></mat-datepicker-toggle>
        <mat-datepicker #closingDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="col-md-6">
        <mat-label>Total Committed Equity</mat-label>
        <input type="number" matInput formControlName="invested_equity">
        <mat-icon matPrefix>attach_money</mat-icon>
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions><button mat-raised-button (click)="dialogRef.close()">Cancel</button><button mat-raised-button color="primary" (click)="saveFund()" [disabled]="formGroup.invalid">Save</button></div>
